<template>
  <modal
      name="CascadeAccess"
      :confirm="$t('button.save')"
      :title="$t('cascade_access.create_cascade_access')"
      :preventHideOnOk="true"
      @ok="okButtonPressed"
      @hidden="clearCascadeAccessData"
  >
    <template slot="body">
      <b-row>
        <b-col md="12">
          <group-select :input="resourceInputConfig"
                        :groupSelect="false"
                        @select="onSelectResource"
                        @remove="onSelectResource"
                        valueKey="key"
          >
          </group-select>
        </b-col>

        <b-col md="12" class="mt-4">
          <group-select :input="typeInputConfig"
                        :groupSelect="false"
                        @select="onSelectType"
                        @remove="onSelectType"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        v-if="selectedResource && selectedType === 'type_subscription'"
                        :input="subscriptionInputConfig"
                        :requestHeaders="headers"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        v-if="selectedResource && selectedType === 'type_ticket'"
                        :input="ticketInputConfig"
                        :requestHeaders="headers"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        v-if="selectedResource &&selectedType === 'type_content'"
                        :input="contentInputConfig"
                        :requestHeaders="headers"
                        :groupSelect="false"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12" class="mt-4">
          <label :for="activeInputConfig.name">{{ activeInputConfig.label }}
            <span class="text-danger">
              {{ $t('form.required_star') }}
            </span>
          </label>
          <div class="d-flex flex-row input-height align-items-center">
            <label class="switch switch-3d switch-success mb-0">
              <b-form-checkbox type="checkbox"
                               class="switch-input"
                               v-model="selectedActive"
              />
              <input type="checkbox"
                     class="switch-input"
                     :checked="selectedActive"
              >
              <span class="switch-slider"></span>
            </label>
          </div>
        </b-col>

      </b-row>
    </template>
  </modal>
</template>

<script>

import i18n from "@/utils/i18n";
import GroupSelect from "@/components/global/groupSelect";
import {get, isNull} from "lodash";

export default {
  name: "CascadeAccessModal",
  props: {
    partnerId: {
      type: Number,
      required: true
    }
  },
  components: {
    GroupSelect
  },
  data() {
    return {
      resourceInputConfig: {
        name: "cascadeAccessResource",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        group: false,
        label: i18n.t('cascade_access.resource'),
        placeholder: i18n.t('cascade_access.please_select'),
        options_url: "partner/resources",
      },
      typeInputConfig: {
        name: "cascadeAccessType",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        group: false,
        options: [
          {
            label: i18n.t('cascade_access.type_subscription'),
            value: "type_subscription"
          },
          {label: i18n.t('cascade_access.type_ticket'), value: "type_ticket"},
          {label: i18n.t('cascade_access.type_content'), value: "type_content"},
        ],
        label: i18n.t('cascade_access.type'),
      },
      subscriptionInputConfig: {
        name: "cascadeAccessSubscription",
        type: "select",
        label: i18n.t('form.plan_subscription'),
        placeholder: i18n.t('cascade_access.please_select'),
        required: true,
        searchable: true,
        multiple: false,
        assembleValues: true,
        filter_field: 'title',
        options_url: "plans?limit=100",
      },
      ticketInputConfig: {
        name: "cascadeAccessTicket",
        type: "select",
        label: i18n.t('form.event_and_ticket'),
        placeholder: i18n.t('cascade_access.please_select'),
        required: true,
        searchable: true,
        multiple: false,
        assembleValues: true,
        filter_field: 'title',
        items_key: "tickets",
        options_url: "ti-events?limit=100",
      },
      contentInputConfig: {
        name: "cascadeAccessContent",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        group: false,
        label: i18n.t('form.contents'),
        placeholder: i18n.t('cascade_access.please_select'),
        options_url: "content?limit=100",
      },
      activeInputConfig: {
        label: i18n.t('form.active'),
        placeholder: i18n.t('form.active'),
        name: 'cascadeAccessActive'
      },
      selectedResource: null,
      selectedType: null,
      selectedSubscription: null,
      selectedTicket: null,
      selectedContent: null,
      selectedSource: null,
      selectedActive: true,
      headers: null
    }
  },
  methods: {
    okButtonPressed() {
      if (isNull(this.selectedSource)) {
        return this.$noty.error(i18n.t('cascade_access.fil_in_all_required_fields'));
      }
      this.createCascadeAccess();
    },
    clearCascadeAccessData() {
      this.selectedResource = null;
      this.selectedType = null;
      this.selectedActive = false;
      this.clearCascadeAccessSourceData();
      this.$forceUpdate()
    },
    clearCascadeAccessSourceData() {
      this.selectedSource = null;
      this.selectedSubscription = null;
      this.selectedTicket = null;
      this.selectedContent = null;
    },
    createCascadeAccess() {
      this.selectedSource["active"] = this.selectedActive;
      this.loading = true
      this.postData(`partners/${this.partnerId}/cascade-access`,
          {...this.selectedSource})
          .then(() => {
            this.$bus.$emit('reloadCascadeAccesses');
            this.$bus.$emit('closeCascadeAccessModal');
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
          .finally(() => this.loading = false)
    },
    getCascadeAccessType(item) {
      if (item.subscription_id) return i18n.t('cascade_access.type_subscription');
      if (item.ti_event_ticket_id) return i18n.t('cascade_access.type_ticket');
      if (item.content_id) return i18n.t('cascade_access.type_content');
    },
    onSelectResource(obj) {
      this.selectedResource = get(obj, "value.value", null);
    },
    onSelectType(obj) {
      this.selectedType = get(obj, "value.value", null);
    },
    onSelectSource(source) {
      switch (this.selectedType) {
        case "type_subscription":
          this.selectedSource = {
            "subscription_id": get(source, "value.value", null)
          }
          break;
        case "type_ticket":
          this.selectedSource = {
            "ti_event_ticket_id": get(source, "value.value", null)
          }
          break;
        case "type_content":
          this.selectedSource = {
            "content_id": get(source, "value.value", null)
          }
          break;
      }
    },
  },
  watch: {
    selectedResource() {
      this.clearCascadeAccessSourceData();
      this.headers = {'resource': this.selectedResource};
    },
    selectedType() {
      this.clearCascadeAccessSourceData();
    }
  }
}
</script>
